import { shopPrefix } from '../../../../config';
import { http } from '../../../../api/axios';
import { CompleteCollectionAnalyseResponseOut } from '../../../../store/api';

const url = `${shopPrefix}/v1/analyse/collection`;

export const fetchCollectionAnalyse = () => {
    return http.get<CompleteCollectionAnalyseResponseOut>(url).then(response => response.data);
};
